import React from 'react'
import { Button, CardContent, DialogActions, Divider, Typography } from '@mui/material'
import { EbListItemText } from '@eidsivabredband/react-component-ui-package'
import type { EventClickArg } from '@fullcalendar/core'

interface CalendarEventPopoverProps {
  info: EventClickArg
}

const CalendarEventPopover: React.FC<CalendarEventPopoverProps> = ({ info }: CalendarEventPopoverProps) => {
  const dateTimeFormatter = Intl.DateTimeFormat('no', { month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' })
  const timeFormatter = Intl.DateTimeFormat('no', { hour: 'numeric', minute: 'numeric' })

  const { event } = info

  const goToEvent = (eventId: string) => {
    window.open(`/events/${event.id}`, '_blank', 'noopener,noreferrer')
  }

  return (
    <CardContent>
      <Typography variant="h6" sx={{
        fontWeight: 'bold'
      }}>
        {event.title}
      </Typography>
      {event.extendedProps.eventStartDate && (
        <Typography variant="caption">
          {info.event.allDay
            ? dateTimeFormatter.format(new Date(event.extendedProps.eventStartDate))
            : timeFormatter.format(new Date(event.extendedProps.eventStartDate))}
        </Typography>
      )}
      {event.extendedProps.eventEndDate && (
        <Typography variant="caption">
          -{' '}
          {info.event.allDay
            ? dateTimeFormatter.format(new Date(event.extendedProps.eventEndDate))
            : timeFormatter.format(new Date(event.extendedProps.eventEndDate))}
        </Typography>
      )}
      <Divider sx={{ mb: 2, mt: 1 }} />
      {info.event.id && <EbListItemText primary={'Id'} secondary={info.event.id} />}
      {event.extendedProps.type && <EbListItemText primary={'Type'} secondary={event.extendedProps.type} />}
      <EbListItemText primary={'Status'} secondary={event.extendedProps.status} />
      <EbListItemText primary={'Berørte'} secondary={event.extendedProps.affectedEntitiesCount} />
      {event.extendedProps.responsible.name && <EbListItemText primary={'Ansvarlig'} secondary={event.extendedProps.responsible.name} />}
      <DialogActions sx={{ justifyContent: 'center', pt: 2 }}>
        <Button sx={{ width: '100%' }} onClick={() => goToEvent(event.id)}>
          Til hendelse
        </Button>
      </DialogActions>
    </CardContent>
  );
}

export default CalendarEventPopover
